import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import NotificationSettingsTable from './components/NotificationSettingsTable';

const NotificationSettingsIndex = () => {
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Notification Settings</h3>
                    <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / Notification Settings</h3>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <NotificationSettingsTable />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default NotificationSettingsIndex;
